"use client";

import { useSentryErrorBoundary } from "@/lib/sentry/use-sentry-error-boundary";

/**
 * global-error.tsx catches errors that propagate from the root layout itself.
 * Unlike error.tsx, this MUST render its own <html> and <body> tags because
 * the root layout may have failed to render.
 *
 * Keep this minimal — no imports from the app's component library since the
 * root layout (which loads CSS/fonts) may not have rendered.
 */
export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useSentryErrorBoundary(error);

  return (
    <html lang="en">
      <body
        style={{
          margin: 0,
          fontFamily:
            '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
          display: "flex",
          minHeight: "100vh",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "#fafafa",
          color: "#171717",
        }}
      >
        <div style={{ maxWidth: 420, textAlign: "center", padding: 24 }}>
          <h1 style={{ fontSize: 24, fontWeight: 600, marginBottom: 8 }}>
            Something went wrong
          </h1>
          <p style={{ fontSize: 14, color: "#737373", marginBottom: 16 }}>
            An unexpected error occurred. Please try again.
          </p>
          {error.digest && (
            <p style={{ fontSize: 12, color: "#a3a3a3", marginBottom: 16 }}>
              Error ID: {error.digest}
            </p>
          )}
          <button
            onClick={reset}
            style={{
              padding: "8px 16px",
              fontSize: 14,
              fontWeight: 500,
              backgroundColor: "#171717",
              color: "#fafafa",
              border: "none",
              borderRadius: 6,
              cursor: "pointer",
            }}
          >
            Try again
          </button>
        </div>
      </body>
    </html>
  );
}
